"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRequestDTOSchema = exports.PaymentDTO = exports.PaymentDTOSchema = exports.PaymentSchema = exports.PaymentBaseSchema = exports.PAYMENT_STATUS = exports.PAYMENT_SYSTEM = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var MembershipStatus_1 = require("./MembershipStatus");
var User_1 = require("./User");
var PAYMENT_SYSTEM;
(function (PAYMENT_SYSTEM) {
    PAYMENT_SYSTEM["STRIPE"] = "Stripe";
    // BANK_ACCOUNT = 'Bank account',
})(PAYMENT_SYSTEM || (exports.PAYMENT_SYSTEM = PAYMENT_SYSTEM = {}));
var PAYMENT_STATUS;
(function (PAYMENT_STATUS) {
    PAYMENT_STATUS["UNPAID"] = "Unpaid";
    PAYMENT_STATUS["PENDING"] = "Pending";
    PAYMENT_STATUS["PAID"] = "Paid";
    PAYMENT_STATUS["REFUND"] = "Refund";
})(PAYMENT_STATUS || (exports.PAYMENT_STATUS = PAYMENT_STATUS = {}));
exports.PaymentBaseSchema = zod_1.z.object({
    order: zod_1.z.string().optional(),
    date: zod_1.z.coerce.date(),
    membershipStatusId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    amount: zod_1.z.coerce
        .number({ invalid_type_error: 'The entered amount is not valid' })
        .min(0, { message: 'The minimum amount needs to be greater than 0' }),
    paidBy: zod_1.z.nativeEnum(PAYMENT_SYSTEM).default(PAYMENT_SYSTEM.STRIPE),
    paymentMethod: zod_1.z.string(), // probably we can take this value from the payment system response
    status: zod_1.z.nativeEnum(PAYMENT_STATUS).default(PAYMENT_STATUS.UNPAID),
    invoiceId: zod_1.z.string(),
    userId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    stripeSession: zod_1.z.any().optional(),
});
exports.PaymentSchema = exports.PaymentBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.PaymentDTOSchema = exports.PaymentSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelDTOFields), { membershipStatusId: (0, ObjectId_1.ObjectIdString)('Invalid membershipStatusId'), userId: (0, ObjectId_1.ObjectIdString)('Invalid UserId') }));
exports.PaymentDTO = {
    convertFromModel: function (model) {
        // There seem to be payments without a membership status for some reason...
        var membershipStatusId = !model.membershipStatusId
            ? ''
            : model.membershipStatusId._id
                ? model.membershipStatusId._id.toString()
                : model.membershipStatusId.toString();
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            order: model.order,
            date: model.date,
            amount: model.amount,
            paidBy: model.paidBy,
            paymentMethod: model.paymentMethod,
            status: model.status,
            invoiceId: model.invoiceId,
            membershipStatusId: membershipStatusId,
            membershipStatus: (0, ObjectId_1.isPopulated)(model.membershipStatusId)
                ? MembershipStatus_1.MembershipStatusDTO.convertFromModel(model.membershipStatusId)
                : undefined,
            userId: model.userId._id ? model.userId._id.toString() : model.userId.toString(),
            user: (0, ObjectId_1.isPopulated)(model.userId) ? User_1.UserDTO.convertFromModel(model.userId) : undefined,
        };
        return dto;
    },
};
exports.PaymentRequestDTOSchema = exports.PaymentDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { membershipStatusId: (0, ObjectId_1.ObjectIdString)('Invalid membershipStatusId', 'Select a Membership to continue'), status: exports.PaymentDTOSchema.shape.status.optional() }));
//# sourceMappingURL=Payment.js.map